import { apiTransformer } from 'utils';

export const clubToApiTransformer = values => {
    // An empty head-club select means "no head club". Left as '' it would
    // become the IRI '/api/clubs/' — the API needs an explicit null to clear
    // the relation.
    const normalised = { ...values };
    if ('parentClub' in normalised && !normalised.parentClub) {
        normalised.parentClub = null;
    }

    return {...apiTransformer(normalised, ['location', 'association', 'parentClub'])};
}
